import { Configuration, PopupRequest, BrowserCacheLocation } from "@azure/msal-browser";

// Configuração do Azure AD
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "6fa1c56c-85cc-4f04-9157-f54821cfbedb",
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || "e12b45bf-b0b5-4fb8-a3e1-e071cdcf81dd"}`,
        redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
        postLogoutRedirectUri: "http://localhost:3000",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: true,
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                // Logs removidos para manter o código limpo
            },
            logLevel: 2, // Info level
        }
    }
};

// Escopos necessários para a aplicação
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "email", "profile", "openid"]
};

/**
 * Base da API.
 * - Homolog/prod: REACT_APP_API_URL = origem pública (ex. https://tools.hom.levesaude.com.br)
 *   ou vazio → same-origin (nginx faz proxy de /api e /convert para :8001).
 * - Dev local: fallback http://localhost:8000.
 * Nunca use http://127.0.0.1:8001 no browser (porta interna do servidor).
 */
function resolveApiEndpoint(): string {
    const configured = process.env.REACT_APP_API_URL;
    if (configured !== undefined && configured !== null && String(configured).trim() !== "") {
        // Origem pública apenas — paths do frontend já começam com /api/...
        return String(configured).trim().replace(/\/$/, "").replace(/\/api$/i, "");
    }
    if (process.env.NODE_ENV === "production") {
        return "";
    }
    return "http://localhost:8000";
}

export const protectedResources = {
    api: {
        endpoint: resolveApiEndpoint(),
        scopes: ["User.Read"],
    },
};
